import React, {useCallback, useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
    getFlatCode,
    maintenanceVaild,
} from "../../../components/commonmethod/CommonMethod";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailFormTabChrome,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import Th_title from "../../../components/Th_title";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {getWork, updateWork} from "../../../api/maintenance/WorkService";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {useDispatch, useSelector} from "react-redux";
import {inspectionRequestCode, useSla} from "../inspection/InspectionCreate";
import {
    changeProgressStatusValue,
    changeStatusNumericValue,
} from "../../../redux/slice/contentSlice";
import {
    clearApprovalProcessState,
    getApprovalProcessSubmitPayload,
    preloadApprovalProcessFromFlatCode,
} from "../../settings/approval/shared/approvalProcessStore";
import {connectedInfoRadio, workAcceptCode} from "./WorkCreate";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {selectHandlers} from "../../../api/handler/handlerService";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import Selector from "../../../components/selector/Selector";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import {selectCodesByParentId} from "../../../api/code/CodeService";

function WorkUpdate(){
    const {id} = useParams();
    const dispatch = useDispatch();
    const [work, setWork] = useState({});
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const [flatWorkCode, setFlatWorkCode] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);
    const approvalProcessIdAfter = useSelector((state) => state.content.approvalProcessAfter?.id);

    const preloadApprovalProcesses = useCallback((workCodeId, flatList) => {
        preloadApprovalProcessFromFlatCode(dispatch, workCodeId, flatList);
    }, [dispatch]);

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch, id]);

    useEffect(() =>{
        Promise.all([
            getWork(id),
            selectHandlers({ contentId: id, contentCategory: ContentCategory.WORK }),
            getContentStatus({contentId : id, contentCategory : ContentCategory.WORK})
        ]).then(([workResponse, handlersResponse, statusNumericValueResponse]) => {
            setWork((prev) => ({
                ...workResponse.data,
                connectedId: workResponse.data.service?.id ||
                    workResponse.data.inspect?.id ||
                    workResponse.data.incident?.id,
                connectedObject: workResponse.data.service ||
                    workResponse.data.inspect ||
                    workResponse.data.incident
            }));

            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {
                const numericValue = statusNumericValueResponse.data.statusNumericValue;
                dispatch(changeStatusNumericValue(numericValue));
                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
            }

            setAssets(workResponse.data.maintenanceAssets?.map(each => each.assets));
            setHandler(handlersResponse.data);

            return selectCodesByParentId(CodeSpecNum.WorkRequestCode)
                .then(incidentCodeResponse => {
                    setFlatWorkCode(getFlatCode(incidentCodeResponse));
                })
        }).finally(
            dispatch(skeleton(false))
        )
    }, [id, dispatch])

    useEffect(() => {
        if (!work.workCode?.id || flatWorkCode.length === 0) {
            return;
        }

        preloadApprovalProcesses(work.workCode.id, flatWorkCode);
    }, [work.workCode?.id, flatWorkCode, preloadApprovalProcesses]);

    const requireds =["title", "requester", "workCode", "workStartDate", "workEndDate", "title", "useSla", "inspector"]
    const update = async ()=>{
        if(assets.length == 0){
            alert("자산을 선택해주세요")
            return false;
        }

        if (!maintenanceVaild(handler, work, requireds)) return;

        if(work.connectedInfo != ContentCategory.NONE && !work.connectedId){
            alert("연계정보를 선택해주세요");
            return;
        }

        dispatch(apiLoading(true));

        const data = {
            ...work,
            workCode : {id : work.workCode.id},
            inspector : {id : work.inspector.id},
            requester : {id : work.requester.id},
            location : work.location? {id : work.location.id} : null,
            ...getApprovalProcessSubmitPayload({includeAfter: true}),
        }

        const response = await updateWork(data, assets, handler);
        if(response.status === 200){
            dispatch(apiLoading(false));
            alert("작업이 접수되었습니다.")
            navigate("/maintenance/work/"+id, {
                state: {
                    test: location.state
                }
            });
        }
    }

    const onChangeConnectedInfo = (each) => {
        setWork((prev) => ({
            ...prev,
            connectedId : each.id,
            connectedObject : each
        }))
    }

    const handleRadioInfo = (each) => {
        setWork((prev) => {
            const { connectedObject, connectedId, ...rest } = prev; // connectedObject와 connectedId를 제외
            return {
                ...rest,
                connectedInfo: each,
            };
        });
    };

    const goToDetail = () => navigate(`/maintenance/work/${id}`);

    const requestInfoPanel = Object.keys(work).length > 0 ? (
        <DetailPanel title="작업요청정보">
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth={work.auth?.update}>
                            <UserSelectionField
                                layout="inline"
                                data={assets}
                                countUnit="개"
                                chipEntity="asset"
                                listModalTitle="자산목록"
                                onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                            >
                                <SearchSelector
                                    auth={work.auth?.update}
                                    multiSelect
                                    variant="compact"
                                    entity="maintenance-assets"
                                    uniqueKey="assets"
                                    data={assets}
                                    onChange={(v) => {
                                        if (v?.__multiFlat) setAssets(v.__multiFlat);
                                    }}
                                >
                                    <SimmsInputSearch type="TEXT" />
                                    <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive />
                                    <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive />
                                    <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive />
                                    <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive />
                                    <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator" />
                                    <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler" />
                                </SearchSelector>
                            </UserSelectionField>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="작업연계정보" colspan={3} className="fieldset-td relative align-top" auth={work.auth?.update}>
                            <SimmsRadio
                                options={connectedInfoRadio}
                                onChange={(v) => handleRadioInfo(v)}
                                data={work.connectedInfo}
                            />
                        </Th_title>
                    </tr>
                    {work.connectedInfo !== ContentCategory.NONE && (
                        <tr>
                            <Th_title title="연계정보 선택" colspan={3} className="fieldset-td" auth={work.auth?.update}>
                                <Selector
                                    onChange={(v) => onChangeConnectedInfo(v)}
                                    data={work.connectedObject}
                                    entity={work.connectedInfo}
                                    uniqueKey={work.connectedInfo}
                                >
                                    <SimmsInputSearch type="TEXT" placeHolder="연계정보명" />
                                </Selector>
                            </Th_title>
                        </tr>
                    )}
                    {work.connectedObject && (
                        <tr>
                            <Th_title title="연계정보" colspan={3} className="fieldset-td relative align-top" auth={work.auth?.update}>
                                <div>제목 : {work.connectedObject.title}</div>
                                <div>등록일 : {work.connectedObject.createdAt}</div>
                                <div>수정일 : {work.connectedObject.updatedAt}</div>
                            </Th_title>
                        </tr>
                    )}
                    <tr>
                        <Th_title title="등록일시" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="createdAt" value={work.createdAt} />
                        </Th_title>
                        <Th_title title="등록자" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="createdBy" value={work.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="수정일시" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="updatedAt" value={work.updatedAt} />
                        </Th_title>
                        <Th_title title="수정자" colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target="updatedBy" value={work.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="요청자" colspan={3} className="fieldset-td" required auth={work.auth?.update}>
                            <Selector
                                onChange={(v) => onCreateClickListener(setWork, "requester", work.requester, v)}
                                data={work.requester}
                                entity="userAccount"
                                uniqueKey="requester"
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                            </Selector>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="작업종류" colspan={1} className="fieldset-td" required auth={work.auth?.update}>
                            <Selector
                                onChange={(v) => onCreateClickListener(setWork, "workCode", work.workCode, v)}
                                data={work.workCode}
                                entity="code"
                                parentKey={CodeSpecNum.WorkRequestCode}
                                recursive
                            />
                        </Th_title>
                        <Th_title title="요청방식" colspan={1} className="fieldset-td" auth={work.auth?.update}>
                            <SelectComboBoxForCreate
                                target="workRequest"
                                options={inspectionRequestCode}
                                data={{data: work, fnc: setWork}}
                                defaultValue={work.workRequest}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="작업인지" colspan={1} className="fieldset-td" auth={work.auth?.update}>
                            <div className="flex items-center gap-1 w-full min-w-0">
                                <SelectComboBoxForCreate
                                    target="workAcceptCode"
                                    options={workAcceptCode}
                                    data={{data: work, fnc: setWork}}
                                    defaultValue={work.workAcceptCode}
                                />
                                <SimmsInput
                                    onChange={(v) => inputOnChange(setWork, "workAcceptText", v, false)}
                                    data={work.workAcceptText}
                                    style={{flex: "1 1 auto", minWidth: 0, width: "auto"}}
                                />
                            </div>
                        </Th_title>
                        <Th_title title="작업위치" colspan={1} className="fieldset-td fieldset-td-input" auth={work.auth?.update}>
                            <Selector
                                onChange={(v) => onCreateClickListener(setWork, "location", work.location, v)}
                                data={work.location}
                                entity="code"
                                parentKey={CodeSpecNum.AssetLocation}
                                recursive
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="작업기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setWork, "workStartDate", v, true)}
                                    data={work.workStartDate}
                                    constraint={{lessThan: work.workEndDate && dayjs(work.workEndDate)}}
                                    auth={work.auth?.update}
                                />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setWork, "workEndDate", v, true)}
                                    data={work.workEndDate}
                                    constraint={{largerThan: work.workStartDate && dayjs(work.workStartDate)}}
                                    auth={work.auth?.update}
                                />
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="작업 제목" colspan={3} className="fieldset-td" required auth={work.auth?.update}>
                            <SimmsInput onChange={(v) => inputOnChange(setWork, "title", v, true)} data={work.title} />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="작업내용" colspan={3} className="fieldset-td" auth={work.auth?.update}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setWork, "workContent", v, false)} data={work.workContent} style={{width: "100%", minHeight: "80px"}} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title="SLA 사용여부" colspan={3} className="fieldset-td" required auth={work.auth?.update}>
                            <SimmsRadio
                                options={useSla}
                                onChange={(v) => inputOnChange(setWork, "useSla", v, true)}
                                data={work.useSla}
                            />
                        </Th_title>
                    </tr>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title="비고" colspan={3} className="fieldset-td" auth={work.auth?.update}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setWork, "etc", v, false)} data={work.etc} style={{width: "100%", minHeight: "80px"}} />
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    ) : null;

    const workflowPanels = Object.keys(work).length > 0 ? (
        <>
            <DetailPanel title="작업 요청 진행상태">
                <DetailKvTable>
                    <tbody>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth={work.auth?.update}>
                                <UserSelectionField
                                    layout="inline"
                                    data={handler}
                                    onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                                >
                                    <SearchSelector
                                        auth={work.auth?.update}
                                        multiSelect
                                        variant="compact"
                                        entity="userAccount"
                                        uniqueKey="handler"
                                        data={handler}
                                        onChange={(v) => {
                                            if (v?.__multiFlat) setHandler(v.__multiFlat);
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                    </SearchSelector>
                                </UserSelectionField>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title="검수자" colspan={3} className="fieldset-td" required auth={work.auth?.update}>
                                <Selector
                                    onChange={(v) => onCreateClickListener(setWork, "inspector", work.inspector, v)}
                                    data={work.inspector}
                                    entity="userAccount"
                                    uniqueKey="inspector"
                                >
                                    <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                    <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                    <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                </Selector>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    ) : null;

    const asidePanel = Object.keys(work).length > 0 ? (
        <>
            <ApprovalComponent auth={work.auth?.update} approvalProcessId={approvalProcessId} />
            <ApprovalComponent auth={work.auth?.update} title="사후결재" approvalSeparator approvalProcessId={approvalProcessIdAfter} />
            <DetailFilePanel
                title="첨부"
                isEditing={Boolean(work.auth?.update)}
                tableInfo={{tableName: "Work", joinKey: work.id}}
            />
        </>
    ) : null;

    if (Object.keys(work).length > 0 && Object.keys(flatWorkCode).length > 0) {
        const summaryMeta = [
            work.workCode?.name,
            work.number && `번호 ${work.number}`,
        ].filter(Boolean).join(" · ");

        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray flex min-h-0 flex-1 flex-col">
                <DetailFormTabChrome>
                    <ContentDetailInfoShell
                        title={work.title || "작업 접수"}
                        meta={summaryMeta || undefined}
                        contentId={id}
                        contentCategory={ContentCategory.WORK}
                        scrollMode="columns"
                        actions={
                            <DetailSummaryButton muted onClick={goToDetail}>
                                취소
                            </DetailSummaryButton>
                        }
                        rollup={{
                            update: work.auth?.update ? update : "",
                            updateTitle: "접수완료",
                        }}
                    >
                        <ContentDetailThreeColLayout
                            primary={requestInfoPanel}
                            secondary={workflowPanels}
                            aside={asidePanel}
                        />
                    </ContentDetailInfoShell>
                </DetailFormTabChrome>
            </div>
        );
    }
}

export {WorkUpdate}